export default __webpack_public_path__ + "static/media/Copiar-12.69e9761f.svg";